import ParentSubscriptionsList from "./ParentSubscriptionsList";
import AboutWisWiz from "./AboutWisWiz";
import { useLayoutMode } from "@/hooks/useLayoutMode";
import { useLandingContext } from "@/context/LandingContext";
import WaveSections from "@/containers/layout/WaveSections";
import { useIsStacked } from "@/hooks/useIsStacked";
import type { SectionItem } from "@/containers/layout/WaveSections";
import Container from "../Container";
import { PremiumHomeHero } from "../framerlanding/PremiumLanding";
import About from "../framerlanding/About";

export default function PremiumParentHub() {
  const { sectionRefs } = useLandingContext();
  const { layoutMode } = useLayoutMode();
  const isStacked = useIsStacked();

  const parentHeroSections: SectionItem[] = isStacked
    ? [
        {
          content: (
            <div className="flex justify-center">
              <ParentSubscriptionsList dominant />
            </div>
          ),
          ref: sectionRefs.heroRef
        },
        {
          content: (
            <div className="mt-6">
              <AboutWisWiz hideNewsBanner compact />
            </div>
          )
        }
      ]
    : [
        {
          content: (
            <section className="flex flex-1">
              <Container>
                <div className="mx-auto grid max-w-6xl grid-cols-[minmax(0,1.08fr)_minmax(19rem,0.82fr)] items-start gap-5 py-12 lg:gap-6">
                  <div className="flex justify-center lg:justify-end">
                    <ParentSubscriptionsList dominant />
                  </div>
                  <div className="max-w-md">
                    <AboutWisWiz hideNewsBanner compact />
                  </div>
                </div>
              </Container>
            </section>
          ),
          ref: sectionRefs.heroRef
        }
      ];

  const infoSections: (SectionItem | false)[] = [
    {
      content: (
        <section>
          <Container>
            <div className="px-4 pt-16 text-center md:pt-24">
              <h2 className="text-3xl font-extrabold leading-tight text-gray-950 md:text-5xl">
                Zelf proberen
              </h2>
            </div>
          </Container>
          <PremiumHomeHero
            includeFeedback={false}
            includeDiscovery={layoutMode === "web"}
          />
        </section>
      ),
      ref: sectionRefs.tryWithRealQuestionsRef
    },
    layoutMode === "web" && {
      content: <About />,
      ref: sectionRefs.aboutUsSectionRef
    }
  ];

  return (
    <WaveSections
      sections={[
        ...parentHeroSections,
        ...infoSections
      ]}
    />
  );
}
